import { defineComponent as g, useSlots as h, ref as v, computed as d } from "vue";
import { NcButton as b, NcIconSvgWrapper as N, NcModal as k } from "@nextcloud/vue";
import { useElementSize as y } from "@vueuse/core";
const $ = /* @__PURE__ */ g({
  __name: "DialogButton",
  props: {
    callback: null,
    label: null,
    icon: null,
    type: null
  },
  emits: ["click"],
  setup(t, { emit: e }) {
    const n = t;
    return { __sfc: !0, props: n, emit: e, handleClick: (o) => {
      var l;
      (l = n.callback) == null || l.call(n), e("click", o);
    }, NcButton: b, NcIconSvgWrapper: N };
  }
});
function m(t, e, n, a, o, l, c, _) {
  var s = typeof t == "function" ? t.options : t;
  e && (s.render = e, s.staticRenderFns = n, s._compiled = !0), a && (s.functional = !0), l && (s._scopeId = "data-v-" + l);
  var i;
  if (c ? (i = function(r) {
    r = r || // cached call
    this.$vnode && this.$vnode.ssrContext || // stateful
    this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !r && typeof __VUE_SSR_CONTEXT__ < "u" && (r = __VUE_SSR_CONTEXT__), o && o.call(this, r), r && r._registeredComponents && r._registeredComponents.add(c);
  }, s._ssrRegister = i) : o && (i = _ ? function() {
    o.call(
      this,
      (s.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : o), i)
    if (s.functional) {
      s._injectStyles = i;
      var p = s.render;
      s.render = function(C, f) {
        return i.call(f), p(C, f);
      };
    } else {
      var u = s.beforeCreate;
      s.beforeCreate = u ? [].concat(u, i) : [i];
    }
  return {
    exports: t,
    options: s
  };
}
var B = function() {
  var e = this, n = e._self._c, a = e._self._setupProxy;
  return n(a.NcButton, { attrs: { "aria-label": a.props.label, type: a.props.type }, on: { click: a.handleClick }, scopedSlots: e._u([a.props.icon !== void 0 ? { key: "icon", fn: function() {
    return [typeof a.props.icon == "string" ? n(a.NcIconSvgWrapper, { attrs: { svg: a.props.icon } }) : n(a.props.icon, { tag: "component", attrs: { size: 20 } })];
  }, proxy: !0 } : null], null, !0) }, [e._v(" " + e._s(a.props.label) + " ")]);
}, S = [], w = /* @__PURE__ */ m(
  $,
  B,
  S,
  !1,
  null,
  null,
  null,
  null
);
const D = w.exports, R = /* @__PURE__ */ g({
  __name: "DialogBase",
  props: {
    name: null,
    message: { default: "" },
    additionalTrapElements: { default: () => [] },
    container: { default: void 0 },
    size: { default: "small" },
    buttons: { default: () => [] },
    navigationClasses: { default: () => [] },
    contentClasses: { default: () => [] },
    dialogClasses: { default: () => [] }
  },
  emits: ["close"],
  setup(t, { emit: e }) {
    const n = t, a = h(), o = v(), { width: l } = y(o), c = d(() => l.value < 876), _ = d(() => (a == null ? void 0 : a.navigation) !== void 0), s = v(!0), i = () => {
      s.value = !1, e("close");
    }, p = d(() => ({
      additionalTrapElements: n.additionalTrapElements,
      container: n.container === void 0 ? "body" : n.container,
      name: n.name,
      size: n.size,
      enableSlideshow: !1,
      enableSwipe: !1
    }));
    return { __sfc: !0, props: n, emit: e, slots: a, wrapper: o, dialogWidth: l, isNavigationCollapsed: c, hasNavigation: _, open: s, handleClose: i, modalProps: p, NcModal: k, DialogButton: D };
  }
});
var T = function() {
  var e = this, n = e._self._c, a = e._self._setupProxy;
  return a.open ? n(a.NcModal, e._b({ staticClass: "dialog__modal", on: { close: a.handleClose } }, "NcModal", a.modalProps, !1), [n("h2", { staticClass: "dialog__name", domProps: { textContent: e._s(e.name) } }), n("div", { staticClass: "dialog", class: e.dialogClasses }, [n("div", { ref: "wrapper", class: ["dialog__wrapper", { "dialog__wrapper--collapsed": a.isNavigationCollapsed }] }, [a.hasNavigation ? n("nav", { staticClass: "dialog__navigation", class: e.navigationClasses }, [e._t("navigation", null, { isCollapsed: a.isNavigationCollapsed })], 2) : e._e(), n("div", { staticClass: "dialog__content", class: e.contentClasses }, [e._t("default", function() {
    return [n("p", [e._v(e._s(a.props.message))])];
  })], 2)]), n("div", { staticClass: "dialog__actions" }, [e._t("actions", function() {
    return e._l(a.props.buttons, function(o, l) {
      return n(a.DialogButton, e._b({ key: l, on: { click: a.handleClose } }, "DialogButton", o, !1));
    });
  })], 2)])]) : e._e();
}, z = [], E = /* @__PURE__ */ m(
  R,
  T,
  z,
  !1,
  null,
  "a37caee5",
  null,
  null
);
const M = E.exports;
export {
  M as D,
  m as n
};
